import { lazyWithRetry } from 'app/utils/lazyWithRetry'

export const EditSectionModalLazy = lazyWithRetry(() =>
    import('./editSectionModal').then((m) => ({
        default: m.EditSectionModal,
    }))
)
